var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { CircularProgress, Drawer, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { SimpleForm, TextInput, SaveButton, Toolbar, useRefresh, useGetOne, } from "react-admin";
import { useMutation } from "@apollo/client";
import { INSERT_TENANT } from "../../queries/InsertTenant";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { isNull } from "@sequentech/ui-core";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
export var CreateTenant = function (_a) {
    var _b = _a.isDrawerOpen, isDrawerOpen = _b === void 0 ? true : _b, setIsDrawerOpen = _a.setIsDrawerOpen;
    var createTenant = useMutation(INSERT_TENANT)[0];
    var _c = useState(null), newId = _c[0], setNewId = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var authContext = useContext(AuthContext);
    var _e = useWidgetStore(), addWidget = _e[0], setWidgetTaskId = _e[1], updateWidgetFail = _e[2];
    var t = useTranslation().t;
    var navigate = useNavigate();
    var refresh = useRefresh();
    var closeDrawer = function () {
        if (setIsDrawerOpen)
            setIsDrawerOpen(false);
        else
            navigate("/sequent_backend_tenant");
    };
    var _f = useGetOne("sequent_backend_tenant", {
        id: authContext === null || authContext === void 0 ? void 0 : authContext.tenantId,
    }), newTenant = _f.data, isOneLoading = _f.isLoading, error = _f.error;
    useEffect(function () {
        if (isNull(newId)) {
            return;
        }
        if (isLoading && error && !isOneLoading) {
            setIsLoading(false);
            closeDrawer();
            refresh();
            return;
        }
        if (isLoading && !error && !isOneLoading && newTenant) {
            setIsLoading(false);
            closeDrawer();
        }
    }, [isLoading, newTenant, isOneLoading, error, newId, refresh, authContext, navigate]);
    var onSubmit = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var currWidget, _c, data, errors, taskId, e_1;
        var _d, _e, _f, _g;
        var slug = _b.slug;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.CREATE_TEMANT, undefined);
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createTenant({
                            variables: {
                                slug: slug,
                            },
                        })];
                case 2:
                    _c = _h.sent(), data = _c.data, errors = _c.errors;
                    if (errors || ((_d = data === null || data === void 0 ? void 0 : data.insertTenant) === null || _d === void 0 ? void 0 : _d.error_msg)) {
                        setIsLoading(false);
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    setNewId((_e = data === null || data === void 0 ? void 0 : data.insertTenant) === null || _e === void 0 ? void 0 : _e.id);
                    setIsLoading(true);
                    taskId = (_g = (_f = data === null || data === void 0 ? void 0 : data.insertTenant) === null || _f === void 0 ? void 0 : _f.task_execution) === null || _g === void 0 ? void 0 : _g.id;
                    setWidgetTaskId(currWidget.identifier, taskId);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _h.sent();
                    setIsLoading(false);
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Drawer, { anchor: "right", open: isDrawerOpen, onClose: function () { return closeDrawer(); }, PaperProps: {
            sx: { width: "30%" },
        }, children: _jsxs(SimpleForm, { onSubmit: onSubmit, toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { disabled: isLoading }) }), children: [_jsx(Typography, { variant: "h4", children: "".concat(t("tenantScreen.common.title"), " ").concat(newTenant === null || newTenant === void 0 ? void 0 : newTenant.slug) }), _jsx(Typography, { variant: "body2", children: t("tenantScreen.new.subtitle") }), _jsx(TextInput, { source: "slug", onKeyDown: function (event) { return event.stopPropagation(); } }), isLoading ? _jsx(CircularProgress, {}) : null] }) }));
};
